import { useColorModeValue } from '@chakra-ui/react';

export function useUnifiedTabsStyles() {
  const listBg = useColorModeValue('rgba(239,244,251,0.9)', 'whiteAlpha.100');
  const selectedBg = useColorModeValue('white', 'whiteAlpha.200');
  const selectedColor = useColorModeValue('navy.700', 'white');
  const mutedColor = useColorModeValue('gray.600', 'gray.300');

  const tabListProps = {
    p: 1.5,
    bg: listBg,
    borderRadius: '18px',
    gap: 2,
  };

  const tabProps = {
    borderRadius: '14px',
    fontWeight: '700',
    px: 4,
    py: 2.5,
    color: mutedColor,
    _selected: {
      bg: selectedBg,
      color: selectedColor,
      boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
    },
  };

  return { tabListProps, tabProps };
}

export function useUnifiedTableStyles() {
  const panelBg = useColorModeValue('rgba(255,255,255,0.92)', 'rgba(13,23,53,0.72)');
  const panelBorder = useColorModeValue('rgba(226, 232, 240, 0.9)', 'rgba(255,255,255,0.14)');
  const tableStripe = useColorModeValue('gray.50', 'whiteAlpha.50');
  const tableHover = useColorModeValue('blue.50', 'whiteAlpha.100');

  const tableSx = {
    '& thead th': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      bg: panelBg,
      borderBottom: '1px solid',
      borderColor: panelBorder,
      whiteSpace: 'nowrap',
      fontSize: '11px',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      color: useColorModeValue('gray.500', 'gray.300'),
    },
    '& tbody tr:nth-of-type(even)': {
      bg: tableStripe,
    },
    '& tbody tr:hover': {
      bg: tableHover,
    },
    '& tbody td': {
      verticalAlign: 'top',
    },
  };

  return { panelBg, panelBorder, tableSx };
}

export default useUnifiedTabsStyles;
